import { createMyRolesTable } from '../../../../components/AdminUsersPage/MyRolesTab/createMyRolesTable.ts';
import { $$roles } from '../../../../services/RolesService/model.ts';

export const $$resellerMyRolesTable = createMyRolesTable({
  getManageableRolesFx: $$roles.getManageableRolesFx
});